var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"120%","height":"120%"},attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }